export default __webpack_public_path__ + "static/13-d9ced858f9df4ac81ad1cf681550f3c1.png";